import z from "zod";

import { required } from "@/common/schemas/validators";
import { createEnumFromObjectValues } from "~/common/helpers/enum";
import { SHARED_DOWNLOADABLE_FILES_SOURCE_TYPE } from "~/constants";

export function useEventShareDownloadableFilesSchema() {
  const { t } = useI18n();

  const schema = z.object({
    type: z.enum(createEnumFromObjectValues(SHARED_DOWNLOADABLE_FILES_SOURCE_TYPE)).optional(),
    angles: z.array(z.string()),
    emails: required(
      z
        .array(z.string())
        .min(1, t("errors.no_email_addresses"))
        .max(20, t("errors.max_email_addresses", { max: 20 }))
        .superRefine((emails, ctx) => {
          const invalidSeparation = emails.filter((email) => /[\n\s]/.test(email));

          if (invalidSeparation.length > 0) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t("validation.multiple_emails_separation"),
              path: [],
            });
          }

          const invalidEmails = emails.filter((email) => !z.string().email().safeParse(email).success);

          if (invalidEmails.length > 0) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t("validation.email_invalid", 1),
              path: [],
            });
          }
        })
    ),
  });

  return { schema };
}

export type TEventShareDownloadableFilesSchema = z.infer<ReturnType<typeof useEventShareDownloadableFilesSchema>["schema"]>;
